<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="基本信息" name="base">
        <edit-form
          ref="editForm"
          :disabled="disabled"
          :clientCode="clientCode"
          :appKey.sync="appKey"
        />

        <div class="d-flex justify-content-end mb-2 mt-2">
          <el-button
            v-if="!disabled"
            type="primary"
            size="small"
            @click="$refs.editForm.save()"
          >
            保存
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="权限范围"
        name="orgScope"
        :disabled="!clientCode"
        lazy
      >
        <OrgScope :clientCode="clientCode" :disabled="disabled" />
      </el-tab-pane>
      <el-tab-pane label="字典对照" name="dict" :disabled="!clientCode" lazy>
        <Dict :appKey="appKey" :disabled="disabled" />
      </el-tab-pane>
      <el-tab-pane
        label="推送接口设置"
        name="pushapi"
        :disabled="!clientCode"
        lazy
      >
        <Pushapi :appKey="appKey" :disabled="disabled" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import OrgScope from '../components/org-scope'
import Dict from '../components/dict'
import Pushapi from '../components/pushapi'
export default {
  name: 'openapi-client-detail',
  components: { EditForm, OrgScope, Dict, Pushapi },
  data() {
    return { activeName: 'base', appKey: '' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    clientCode() {
      return this.params.clientCode
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
}
</script>
